module.exports = __webpack_public_path__ + "img/ajil_olgogch_icon.92e69dcb.svg";